import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';

import { SlotSharedComponent } from './slot.component';
import { SlotService } from './slot.service';

import { TextNavSharedModule } from '../text.nav/text.nav.module';

import { TransformTimeModule } from '../../../shared/pipe/time/pipe.time.module';
import { TransformDurationModule } from '../../../shared/pipe/duration/pipe.duration.module';

@NgModule({
    declarations: [
        SlotSharedComponent
    ],
    imports: [
        CommonModule,
        TransformTimeModule,
        TextNavSharedModule,
        TransformDurationModule
    ],
    exports: [
        SlotSharedComponent
    ],
    providers: [
        SlotService,
        CurrencyPipe
    ]
})

export class SlotSharedModule {}
